import { createContext, useContext } from 'react';

import type { ColorScheme, ThemeMode } from '../hooks/useThemeMode';

interface ThemeModeContextValue {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  colorScheme: ColorScheme;
}

export const ThemeModeContext = createContext<ThemeModeContextValue>({
  mode: 'system',
  setMode: () => undefined,
  colorScheme: 'light',
});

export const useThemeModeContext = () => useContext(ThemeModeContext);
